<div [ngClass]="{ 'nav-item': inNavbar }" ngbDropdown>
  @if (inNavbar) {
  <a id="language-dropdown" class="nav-link" ngbDropdownToggle display="dynamic">
    {{ currentLanguage | translate }}
  </a>
  } @else {
  <button id="language-dropdown" class="btn btn-sm btn-light" ngbDropdownToggle>
    {{ currentLanguage }}
  </button>
  }
  <ng-template #button>
    <button id="language-dropdown" class="btn btn-sm btn-light" ngbDropdownToggle>
      {{ currentLanguage }}
    </button>
  </ng-template>
  <div ngbDropdownMenu aria-labelledby="language-dropdown" [ngClass]="menuClass">
    @for (language of languages; track language) {
    <button class="dropdown-item" (click)="setLanguage(language)">
      {{ language | translate }}
    </button>
    }
  </div>
</div>
